export default "__VITE_ASSET__k0QzQKbb__"